import React from "react";
import { Button } from "react-bootstrap";

class FilterRequestTypePopover extends React.PureComponent {
  constructor(props) {
    super(props);

    const {
      requestTypes,
      selectedRequestType,
    } = props;

    this.state = {
      requestTypeOptions: requestTypes,
      selectedRequestType,
    };

    this.handleRequestTypeSelected = this.handleRequestTypeSelected.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleApplyFilter = this.handleApplyFilter.bind(this);
  }

  handleRequestTypeSelected(requestTypeId) {
    if (requestTypeId === -1) {
      this.setState({
        selectedRequestType: requestTypeId,
      });
    } else {
      const { selectedRequestType } = this.state;
      this.setState({
        selectedRequestType: _.xor(
          selectedRequestType === -1 ? [] : selectedRequestType,
          [requestTypeId]
        ),
      });
    }
  }

  handleApplyFilter() {
    const { selectedRequestType } =
      this.state;
    this.props.handleRequestTypeFilterChanged({
      selectedRequestType,
    });
    this.props.handleClosePopover();
  }

  handleCancel() {
    // close and nothing happened
    this.props.handleClosePopover();
  }

  render() {
    const {
      selectedRequestType,
      requestTypeOptions,
    } = this.state;

    const { requestTypes } = this.props;

    return (
      <React.Fragment>
        <div className="d-flex mt-1">
          <div className="border-right pr-3">
            <Button
              variant="light"
              size="sm"
              style={styles.allBtn}
              active={selectedRequestType === -1}
              onClick={() => this.handleRequestTypeSelected(-1)}
            >
              All
            </Button>
          </div>
          <div className="pl-3" style={styles.listSection}>
            {requestTypeOptions.map((rt, idx) => {
              return (
                <div
                  key={`rtfilter-${rt}-${idx}`}
                  className="d-inline"
                  data-tip
                  data-for={`rtfilter-${rt}`}
                >
                  <Button
                    variant="light"
                    style={styles.listBtn}
                    size="sm"
                    data-tip
                    data-for={`rtfilter-${rt}`}
                    active={
                      _.isArray(selectedRequestType) &&
                      _.indexOf(selectedRequestType, rt) !== -1}
                    onClick={() => this.handleRequestTypeSelected(rt)}
                  >
                    {rt}
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
            

        <div className="pt-3 mt-3 border-top d-flex justify-content-end">
          <Button variant="link" className="px-4" onClick={this.handleCancel}>
            Cancel
          </Button>

          <Button
            variant="primary"
            className="px-4"
            onClick={this.handleApplyFilter}
          >
            Apply
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

const styles = {
  allBtn: {
    width: "72px",
    border: "1px solid #D1D5DB",
    color: "#374151",
    marginRight: "4px",
    marginBottom: "4px",
  },
  listSection: {
    maxHeight: "164px",
    overflowY: "auto",
  },
  listBtn: {
    border: "1px solid #D1D5DB",
    color: "#374151",
    marginRight: "4px",
    marginBottom: "4px",
  },
};

export default FilterRequestTypePopover;
